<template>
  <div class="container container-table loginpage">
    <div class="row vertical-10p logincntrrow">
      <div class="container logincntr">
        <div class="text-center col-md-4 col-sm-offset-4 loginFormwrp">
          <img src="/static/img/d2dvoyager-logo.png" class="center-block logina-logo">
          <div class="confirm passwordreset">
            <h2>Reset Password</h2>
             <div class="p-messagebubble">The new password must be 8 character, contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)</div>
             
             <div class="error loginModuleToperror"> <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span><span class="error " v-show="errors.has('username')">{{ errors.first('username') }}</span></div>
             
            <form @submit.prevent="confirm" class="form-resetpassword">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-user"></i>
                </span>
                <input class="form-control" type="text" placeholder="Username" v-model="username" required v-on:blur="validemail" name="username" v-validate="{ email: true }" >
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-user"></i>
                </span>
                <input class="form-control" type="text" placeholder="Confirmation Code" v-model="confirmationCode" required>
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-lock"></i>
                </span>
                <input class="form-control" type="password" placeholder="Password" v-model="password" name="password" required  v-on:blur="validpassword" v-validate="'required|min:8|verify_password'" >
                 
              </div>
              <div class="input-group forgetsubmit">
                <span>If you are facing a issue, contact support on Yammer Group</span>
                <button type="submit" v-bind:class="'loginsubmit btn btn-primary btn-lg'">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  enableAutoClasses: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true
}

Vue.use(VeeValidate, config)
VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
    // eslint-disable-next-line
    var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})')
    return strongRegex.test(value)
  }
})
export default {
  name: 'Confirm',
  data () {
    return {
      username: '',
      confirmationCode: '',
      password: ''
    }
  },
  methods: {
    validpassword () {
      this.$validator.validate('password', this.newpassword)
    },
    validemail () {
      this.$validator.validate('username', this.username)
      if (this.fields.username.valid) {
        var emailCorrecter = String(this.username)
        emailCorrecter = emailCorrecter.split('.')[0].charAt(0).toUpperCase() + emailCorrecter.split('.')[0].slice(1) + '.' + emailCorrecter.split('.')[1].charAt(0).toUpperCase() + emailCorrecter.split('.')[1].slice(1) + '.' + emailCorrecter.split('.')[2]
        this.username = emailCorrecter
      }
    },
    confirm () {
      this.$cognito.confirmPassword(this.username, this.password, this.confirmationCode)
        .then(result => {
          this.$router.replace('/login')
        })
        .then(err => {
          this.error = err
        })
    }
  }
}
</script>
<style scoped>
.input-group.forgetsubmit {
position: relative;
    text-align: right;
    width: 100%;
    color: #444;
    width: 100%;
    text-align: right;
    display: block;
}
.form-resetpassword {
  position: relative;
}
.passwordreset h2 {
  color: #444;
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  margin-top: 0px;
}
.container.logincntr {
    height: 550px;
}
.confirm.passwordreset .input-group {
  padding-bottom: 1em;
  height: 4em;
}

.input-group.forgetsubmit span {
    position: absolute;
    left: 0;
    display: inline-block;
    margin-top: 15px;
}
.p-messagebubble {
  background-color: #d1f5ff;
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #3fb1d2;
  color: #3fb1d2;
}
</style>



// WEBPACK FOOTER //
// PasswordReset.vue?65a6c801